export default function PHP_Exception() {
  return (
    <div>
      <h1>PHP_Exception</h1>
    </div>
  );
}
